export default __webpack_public_path__ + "static/media/whatsapp-logo.7dc3f326.svg";